export default ($state, $scope) => {
  $scope.welcome = 'Welcome to the Profile Manager';
  $scope.select = true;
  $scope.$state = $state;
};
